"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpringboardUserCard = void 0;
var react_1 = __importDefault(require("react"));
var clerk_react_1 = require("@clerk/clerk-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var UserAvatar_1 = require("@CommonFrontend/Public/Springboard/UserAvatar");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var bem = (0, BemBuilder_1.default)("springboard-user-card");
var SpringboardUserCard = function (_a) {
    var _b, _c, _d;
    var onClickSwitchAccounts = _a.onClickSwitchAccounts;
    var signOut = (0, clerk_react_1.useAuth)().signOut;
    var user = (0, clerk_react_1.useUser)().user;
    if (!user) {
        return null;
    }
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: bem() },
        react_1.default.createElement("div", { className: bem("user") },
            react_1.default.createElement(UserAvatar_1.UserAvatar, { url: user.profileImageUrl, name: user.fullName ? user.fullName : (_c = (_b = user.primaryEmailAddress) === null || _b === void 0 ? void 0 : _b.emailAddress) !== null && _c !== void 0 ? _c : "", size: "large" }),
            react_1.default.createElement("div", { className: bem("user-info") },
                !!user.fullName && (react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "m", lineHeight: "compact" }, user.fullName)),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", lineHeight: "compact" }, (_d = user.primaryEmailAddress) === null || _d === void 0 ? void 0 : _d.emailAddress)),
            react_1.default.createElement("div", { className: bem("user-action") },
                react_1.default.createElement(kaleidoscope_1.OptionMenu, { button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null) }), autoStack: false },
                    !!onClickSwitchAccounts && react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: onClickSwitchAccounts }, "Switch account"),
                    react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: function () {
                            signOut();
                        }, closeOnClick: true }, "Log out"))))));
};
exports.SpringboardUserCard = SpringboardUserCard;
